<template>
  <search-and-pick
    :items="employeePickerItems"
    :label="label"
    :multiple="false"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
import SearchAndPick from '@/components/SearchAndPick'
import Employee from '@/dataAccess/models/Employee'

export default {
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  components: { SearchAndPick },
  computed: {
    employeePickerItems() {
      return Employee.all().map(obj => {
        return { name: obj.fullName, avatar: obj.avatar, id: obj.id }
      })
    }
  }
}
</script>
